import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { UserAvatar } from '@/components/UserAvatar';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import DeleteAccountDialog from '@/components/DeleteAccountDialog';
import { LogOut, MapPin, Trash2 } from 'lucide-react';
import { LOGOUT } from '@/constants/testIds';

export const Header = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [deleteOpen, setDeleteOpen] = useState(false);

    const onLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <header
            className="sticky top-0 z-40 backdrop-blur-xl border-b border-[var(--ns-border)]"
            style={{ background: 'rgba(253, 251, 247, 0.85)' }}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <Link to="/dashboard" className="flex items-center gap-2 group" data-testid="header-logo-link">
                    <span
                        className="w-9 h-9 rounded-2xl flex items-center justify-center"
                        style={{ background: 'var(--ns-navy)' }}
                    >
                        <MapPin size={18} className="text-white" />
                    </span>
                    <span className="font-display text-xl font-semibold text-[var(--ns-text)]">NextStop</span>
                </Link>
                {user && (
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <button
                                data-testid={LOGOUT.menuTrigger}
                                className="rounded-full focus:outline-none focus:ring-2 focus:ring-[var(--ns-clay)] focus:ring-offset-2 transition"
                            >
                                <UserAvatar name={user.name} picture={user.picture} size={40} />
                            </button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="end" className="w-60 rounded-2xl">
                            <DropdownMenuLabel className="font-display">
                                <div className="text-sm font-semibold">{user.name}</div>
                                <div className="text-xs text-[var(--ns-text3)] font-normal truncate">{user.email}</div>
                            </DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem onClick={onLogout} data-testid={LOGOUT.button} className="cursor-pointer">
                                <LogOut size={16} className="mr-2" /> Sign out
                            </DropdownMenuItem>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem
                                onClick={() => setDeleteOpen(true)}
                                data-testid="delete-account-menu-item"
                                className="cursor-pointer text-[#D05C45] focus:text-[#D05C45]"
                            >
                                <Trash2 size={16} className="mr-2" /> Delete my account and all data
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                )}
            </div>
            <DeleteAccountDialog open={deleteOpen} onOpenChange={setDeleteOpen} />
        </header>
    );
};

export default Header;
